export enum ControlStatus {
  Valid = 'VALID',
  Invalid = 'INVALID'
}
